import { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';
import { InfoIcon, Tooltip } from '@spotahome/ui-library';
import BrandDiscountMessage from '@spotahome/ui-library/src/tenant/components/BrandDiscountMessage';

import './BookNowPriceTable.scss';
import { usePricingContext } from '../../context/PricingContext';

const DEFAULT_TOTAL_PRICE_DESCRIPTION_GUARANTEE_KEY =
  'listing.book-now-card.total-price-description.guarantee';
const TOTAL_PRICE_DESCRIPTIONS_KEY = {
  london: 'listing.book-now-card.total-price-description.london'
};

const getTotalPriceDescriptionKey = cityId =>
  TOTAL_PRICE_DESCRIPTIONS_KEY[cityId] ??
  DEFAULT_TOTAL_PRICE_DESCRIPTION_GUARANTEE_KEY;

export const BookNowPriceTable = ({
  bookingFee,
  reservationPrice,
  cityId,
  priceClassName = ''
}) => {
  const { formatPrice } = usePricingContext();
  const pricetableClasses = classNames('BookNowPriceTable', {
    'BookNowPriceTable--disabled': bookingFee === ''
  });

  const finalPriceToDisplay = useMemo(
    () => formatPrice(reservationPrice),
    [reservationPrice, formatPrice]
  );

  return (
    <div className={pricetableClasses}>
      <BrandDiscountMessage className="BookNowPriceTable__row" />
      <div
        className={classNames('BookNowPriceTable__totalToPay', priceClassName)}
      >
        <div className="BookNowPriceTable__label BookNowPriceTable__label--highlighted">
          {trans('listing.book-now-card.total-to-pay')}
          <Tooltip
            className="BookNowPriceTable__tooltip"
            textClassName="tooltyp-content__list"
            color="blue-cerulean"
            tooltip={trans('listing.book-now-card.tooltip-price')}
            position="top"
          >
            <InfoIcon size={18} className="question-badge" />
          </Tooltip>
        </div>
        <div className="BookNowPriceTable__value">{finalPriceToDisplay}</div>
      </div>
      <p className="BookNowPriceTable__label BookNowPriceTable__label--subtitle BookNowPriceTable__label--break-early">
        {trans(getTotalPriceDescriptionKey(cityId))}
      </p>
    </div>
  );
};

BookNowPriceTable.propTypes = {
  bookingFee: PropTypes.number.isRequired,
  reservationPrice: PropTypes.number.isRequired,
  cityId: PropTypes.string.isRequired,
  priceClassName: PropTypes.string
};

export default BookNowPriceTable;
